import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material';
import { PaymentCollectionRequest, PaymentMode } from '../../model/payment/PaymentCollectionRequest';
import { ConfigService } from '../../service/config.service';

@Component({
  selector: 'app-payment-mode',
  templateUrl: './payment-mode.component.html',
  styleUrls: ['./payment-mode.component.scss']
})
export class PaymentModeComponent implements OnInit {
  public selectedIndex: number = 3;
  public paymentFormControls:Array<FormGroup> = new Array<FormGroup>(4);
  @Input()
  paymentRequest: PaymentCollectionRequest;
  @Output() currentFormInstanceChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private configService: ConfigService) { }

  ngOnInit(): void {
    if(this.paymentRequest.amount > this.configService.getUPILimitPerDay()){
      this.selectedIndex = 2;
    }
    this.paymentModeSelector(this.selectedIndex);
  }

  private paymentModeSelector(tabIndex: number) {
    switch (tabIndex) {
      case 0:
        this.paymentRequest.paymentMode = PaymentMode.DEBIT_CARD_SAVED;
        break;

      case 1:
        this.paymentRequest.paymentMode = PaymentMode.DEBIT_CARD;
        break;

      case 2:
        this.paymentRequest.paymentMode = PaymentMode.NET_BANKING;
        break;

      case 3:
        this.paymentRequest.paymentMode = PaymentMode.UPI;
        break;
    }
  }

  public onTabChanged(event: MatTabChangeEvent) {
    this.paymentRequest.paymentDetails.paymentIssuerCode = undefined;
    this.paymentRequest.paymentDetails.cardDetails = {
      cardHolderName: null,
      cardNumber: null,
      cardExpiryMonth: null,
      cardExpiryYear: null,
      cardType: null,
      cardCVV: null,
      rememberCard: false
    };
    this.paymentModeSelector(event.index);
    this.paymentFormControls[event.index].reset();
    this.currentFormInstanceChange.emit({index: event.index, currentFormInstance: this.paymentFormControls[event.index]});
  }

  public onFormInstanceCreated(tabIndex:number,formInstance:FormGroup){
    this.paymentFormControls[tabIndex] = formInstance;
    if(tabIndex == this.selectedIndex){
      this.currentFormInstanceChange.emit({index: tabIndex, currentFormInstance: formInstance});
    }
  }
}
